import _ from "lodash";

import {
  CognitoUserPool,
  CognitoUser,
  AuthenticationDetails,
  CognitoUserAttribute
} from "amazon-cognito-identity-js";

const m =
  "Invalid phone number format. Be sure to use a country code: +15550001111";

// Authenticates with email and password,
// returns user details object in promise params
function login(email, password) {
  const authData = {
    Username: email,
    Password: password
  };
  const authDetails = new AuthenticationDetails(authData);

  const userData = {
    Username: email,
    Pool: getUserPool()
  };

  const cognitoUser = new CognitoUser(userData);

  return new Promise((resolve, reject) =>
    cognitoUser.authenticateUser(authDetails, {
      onSuccess: () => loginSuccess(resolve, cognitoUser),
      newPasswordRequired: attributes =>
        resolve({
          newPasswordRequired: true,
          attributes,
          cognitoUser
        }),
      onFailure: reject
    })
  );
}

function loginSuccess(resolve, cognitoUser) {
  return getUserAttributes(cognitoUser).then(attributes =>
    resolve({
      newPasswordRequired: false,
      attributes: toAttributeObject(attributes)
    })
  );
}

function activateAccount(attributes, cognitoUser) {
  const userAttributes = {
    nickname: attributes.email,
    phone_number: attributes.phoneNumber,
    given_name: attributes.givenName,
    family_name: attributes.familyName
  };
  return new Promise((resolve, reject) =>
    cognitoUser.completeNewPasswordChallenge(
      attributes.password,
      userAttributes,
      {
        onSuccess: resolve,
        onFailure: error => {
          error.message === "Invalid phone number format."
            ? reject(new Error(m))
            : reject(error);
        }
      }
    )
  );
}

function getUserPool() {
  const poolData = {
    UserPoolId: process.env.REACT_APP_AWS_COGNITO_USER_POOL_ID,
    ClientId: process.env.REACT_APP_AWS_COGNITO_APP_CLIENT_ID
  };
  return new CognitoUserPool(poolData);
}

function getUserAttributes(cognitoUser) {
  return new Promise((resolve, reject) =>
    cognitoUser.getUserAttributes((error, result) => {
      if (error) {
        reject(error);
        return;
      }
      resolve(result);
    })
  );
}

// Converts array of CognitoUserAttributes like [{ Name: 'name_1', Value: 'value_1'}, ...]
// to an object shaped like { name_1: value_1, name_2: value_2, ... }.
// It also transforms the snake_case keys to camelCase
function toAttributeObject(attributeArray) {
  return _.mapValues(
    _.keyBy(attributeArray, attr => _.camelCase(attr.Name)),
    "Value"
  );
}

// Inverse of toAttributeObject
function toAttributeArray(attributeObject) {
  return _.map(attributeObject, (value, name) => {
    return new CognitoUserAttribute({
      Name: _.snakeCase(name),
      Value: value
    });
  });
}

function getSession() {
  const cognitoUser = getUserPool().getCurrentUser();
  return new Promise((resolve, reject) =>
    cognitoUser.getSession(error => {
      if (error) {
        reject(error);
        return;
      }
      resolve(cognitoUser);
    })
  );
}

function updateAttributes(cognitoUser, attributes) {
  return new Promise((resolve, reject) =>
    cognitoUser.updateAttributes(toAttributeArray(attributes), error => {
      if (error) {
        reject(error);
        return;
      }
      resolve();
    })
  );
}

function updateCurrentUser(attributes) {
  return getSession()
    .then(cognitoUser => updateAttributes(cognitoUser, attributes))
    .catch(error => console.error(error));
}

export default {
  login,
  updateCurrentUser,
  activateAccount
};



// WEBPACK FOOTER //
// ./src/helpers/Cognito.js